// eslint-disable-next-line import/prefer-default-export
export const UPDATE_TASKS = 'UPDATE_TASKS';
